module.exports = __webpack_public_path__ + "static/media/payslipDownload.0a08f206.svg";